import { Box, List, ListItem, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import NextImage from 'next/image';
import { Column, ProcessSection as Props } from '@/types';
import { SectionHeading as SectionAside } from '../ContentSection';
import Section from '../FullSection';
import Heading from '../Heading';
import ArrowButton from '../ArrowButton';
import IconSelector from '../IconSelector';

const iconSize = '1.25em';
const pseudoProcessLine = {
  content: "''",
  display: 'block',
  position: 'absolute',
  bottom: 0,
  left: iconSize,
  top: '.75em',
  width: '1px',
  ml: '-1px',
  borderLeft: '2px dotted var(--chakra-colors-inputBorderColor)',
  zIndex: '-1',
};

const ProcessListItem = ({ title, description, icon, button }: Column) => (
  <ListItem
    pos="relative"
    display="flex"
    _notLast={{ pb: 5, '> *:first-child': { _after: pseudoProcessLine } }}
  >
    <Box sx={{ svg: { lineHeight: '1em' } }} mr="3" zIndex="1">
      <IconSelector
        type={icon}
        size={iconSize}
        bg="highlightColor"
        color="white"
        circle
      />
    </Box>
    <Box>
      <Heading variant="subtitle" as="h3" mb="2">
        {title}
      </Heading>
      <Text mb="2">{description}</Text>
      {button && <ArrowButton {...button} />}
    </Box>
  </ListItem>
);

const ProcessSection = ({ title, lead, data }: Props) => {
  const { t } = useTranslation('frontoffice');

  return (
    <Section title={title}>
      <SectionAside
        as="div"
        pt="6"
        gridRow={title ? 2 : 1}
        display={['none', null, 'block']}
        textAlign="center"
      >
        <NextImage
          src="/contract.svg"
          alt={t('process_signature_alt', 'Allekirjoitus')}
          width="153"
          height="153"
        />
      </SectionAside>
      <Text fontSize="xl" mb={[6, 10]}>
        {lead}
      </Text>
      {data && (
        <List>
          {data.map((item) => (
            <ProcessListItem {...item} key={item.title} />
          ))}
        </List>
      )}
    </Section>
  );
};

export default ProcessSection;
